import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-rm-modal-iccid',
    templateUrl: './rm-modal-iccid.component.html',
    styleUrls: ['./rm-modal-iccid.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmModalIccidComponent implements OnInit {

    constructor(
        public dialog: MatDialogRef<RmModalIccidComponent>
    ) { }

    ngOnInit(): void {
    }

    closeAll() {
        this.dialog.close();
    }

}
